import { actionFailure } from 'src/modules/assistant/actions/createActionHandler';
import {
    TActionStrategy,
    TReplyWhatsappDraft,
} from 'src/modules/assistant/actions/types';
import { buildChannelTarget } from 'src/modules/assistant/actions/helpers/buildChannelTarget';
import { toChannelSendError } from 'src/modules/assistant/actions/helpers/channelSendErrors';
import { CHANNEL_BLOCK_REASON } from 'src/modules/conversations/channels';

/**
 * `channels` areas: sends on the lead's `WarboxConversation` (OmniChannel), the
 * text first and then one message per attachment, in order. Attachments are
 * uploaded before anything is sent so a failed upload sends nothing.
 */
export const sendChannelReply: TActionStrategy<TReplyWhatsappDraft> = async (
    draft,
    { lead, channel, channelMessaging }
) => {
    const { conversation, sendMessage, uploadMedia } = channelMessaging;
    if (!conversation)
        return actionFailure(CHANNEL_BLOCK_REASON.NO_CONVERSATION);
    const target = buildChannelTarget(lead, channel, conversation);

    try {
        const media = await Promise.all(
            (draft.attachments || []).map((file) => uploadMedia(file))
        );
        await sendMessage({
            ...target,
            message: draft.message.trim(),
            isAssistantGenerated: true,
        });
        for (const item of media)
            await sendMessage({
                ...target,
                media: item,
                isAssistantGenerated: true,
            });
        return true;
    } catch (error) {
        return actionFailure(toChannelSendError(error));
    }
};
